import { useEffect } from "react";

const useClickOutside = (
  ref,
  handler,
  eventTypes = ["mousedown", "touchend"]
) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      const timeout = eventTypes.includes("click") ? undefined : 100;
      if (!timeout) {
        handler(event);
      } else {
        setTimeout(() => {
          handler(event);
        }, timeout);
      }
    };

    eventTypes.map((event) => {
      document.addEventListener(event, listener);
    });

    return () => {
      eventTypes.map((event) => {
        document.removeEventListener(event, listener);
      });
    };
  }, [ref, handler]);
};

export default useClickOutside;
